import React from 'react';
import { Link } from 'react-router-dom';
import { FaTelegram, FaInstagram, FaYoutube, FaTwitter, FaArrowUp } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const socialLinks = [
    { icon: FaTelegram, href: 'https://t.me/main_bet', label: 'Telegram', color: 'hover:text-blue-500' },
    { icon: FaInstagram, href: 'https://www.instagram.com/mainbetcom/', label: 'Instagram', color: 'hover:text-pink-500' },
    { icon: FaYoutube, href: '/', label: 'YouTube', color: 'hover:text-red-500' },
    { icon: FaTwitter, href: '/', label: 'Twitter', color: 'hover:text-sky-500' }
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  return (
        <footer className="bg-white dark:bg-dark mt-12 mb-12">
       <div className="container-narrow py-12">
        {/* Main content grid */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand section */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-6">
              <img 
                src="/logo4.png" 
                alt="Main-Bet Logo" 
                className="h-12 w-auto object-contain mr-3"
                loading="lazy"
                width="48"
                height="48"
              />
                             <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
                 Main-Bet
               </h3>
            </div>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed mb-6 max-w-md">
              Professional football predictions and expert betting analysis. 
              Your trusted source for smart betting decisions in 2025.
            </p>
            
            {/* Social links */}
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Follow us on ${social.label}`}
                                         className={`w-10 h-10 bg-gray-100 dark:bg-gray-800 rounded-lg flex items-center justify-center text-gray-600 dark:text-gray-400 transition-all duration-300 hover:bg-gray-200 dark:hover:bg-gray-700 ${social.color}`}
                  >
                    <IconComponent size={18} />
                  </a>
                );
              })}
            </div>
          </div>
          
          {/* Navigation links */}
          <div>
            <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
               Quick Links
             </h4>
            <nav aria-label="Footer navigation">
              <ul className="space-y-3">
                {[
                  { to: '/', label: 'Predictions' },
                  { to: '/accumulators/', label: 'Accumulators' },
                  { to: '/bookie-bonuses/', label: 'Bookmaker Bonuses' },
                  { to: '/betting-guides/', label: 'Betting Guides' },
                  { to: '/about', label: 'About Us' },
                  { to: '/privacy-policy', label: 'Privacy Policy' }
                ].map((link, index) => (
                  <li key={index}>
                    <Link 
                      to={link.to} 
                      className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-all duration-300 hover:translate-x-1 inline-block group"
                    >
                      <span className="group-hover:text-blue-400 transition-colors duration-300">
                        {link.label}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
          
          {/* Legal section */}
          <div>
            <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
               Legal
             </h4>
            <div className="space-y-4">
                             <div className="p-4 bg-yellow-500/10 rounded-lg border border-yellow-500/20">
                <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
                  <span className="text-yellow-400 font-medium">18+</span> Please gamble responsibly. 
                  Our predictions are for informational purposes only.
                </p>
              </div>
              
              <div className="text-xs text-gray-500 dark:text-gray-400 space-y-1">
                <p>Licensed betting content</p>
                <p>Responsible gambling certified</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom section */}
        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700/50">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              &copy; {currentYear} Main-Bet. All rights reserved.
            </p>
            
            {/* Back to top button */}
            <button
              onClick={scrollToTop}
              aria-label="Scroll to top"
                             className="group flex items-center gap-2 px-4 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-200 dark:hover:bg-gray-700 transition-all duration-300"
            >
              <span className="text-sm">Back to top</span>
              <FaArrowUp className="w-3 h-3 transition-transform duration-300 group-hover:-translate-y-1" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 